<mat-card id="case-detailed-lawyer-readonly">
    <mat-card-content >

        <!-- FIRST ROW -->
        <div class="row">

            <!-- FIRST ROW - FIRST COLUMN - LAWYER COMMENTS -->
            <div class="col-sm-8">

                <div class="smp-title mb-4">{{ 'detailed_processing.lawyer.title.lawyer_comments' | translate }}</div>

                <editable-comments [idPrefix]="idPrefix"
                                   [comments]="commentsList?.items"
                                   [readonly]="true">
                </editable-comments>

            </div>


            <!-- FIRST ROW - SECOND COLUMN - DROPZONE DOCUMENTS LIST -->
            <div class="col-sm-4">

                <div class="smp-title">{{ 'detailed_processing.lawyer.title.lawyer_documents' | translate }}</div>

                <case-files-list class="full-width"
                                 *ngIf="caseId && fileMetaCategoryList && fileMetaCategoryList.getFilesByCategory(accidentDocumentCategory) && fileMetaCategoryList.getFilesByCategory(accidentDocumentCategory).entries.length > 0"
                                 [idPrefix]="idPrefix"
                                 [caseId]="caseId"
                                 [(fileMetaCategoryList)]="fileMetaCategoryList"
                                 [smpFileCategory]="accidentDocumentCategory"
                                 [disabledOptions]="disabledOptions">
                </case-files-list>

            </div>

        </div>

    </mat-card-content>
</mat-card>
